<template>
  <v-layout align-start>
    <v-flex xs12>
      <v-toolbar text color="white">
        <v-toolbar-title>Albaranes</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="brown lighten-1 mx-1" fab small dark @click.native="listar()">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn class="green mx-1" fab small dark @click.native="exportarAlbaranesExcel()">
          <v-icon>mdi-file-excel-outline</v-icon>
        </v-btn>
        <v-btn
          class="deep-orange darken-3 mx-1"
          fab
          small
          dark
          @click.native="abrirNuevoAlbaran"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers_albaranes"
        :items="albaranes"
        :items-per-page="50"
        :sort-by="['creacion', 'cod_cliente']"
        :search="filtros_albaranes.otros"
        item-key="_id"
        class="elevation-1"
        :footer-props="{
          itemsPerPageOptions: [15, 50, 100, -1],
        }"
      >
        <template v-slot:top>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 sm6 md2>
                <v-dialog
                  ref="dialogo_filtro_fecha_inicio"
                  v-model="dialogo_filtro_fecha_inicio"
                  :return-value.sync="filtro_remoto_fecha_inicio"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="filtro_remoto_fecha_inicio_formateada"
                      label="Fecha inicio"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filtro_remoto_fecha_inicio"
                    :max="fecha_inicio_maxima"
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="dialogo_filtro_fecha_inicio = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="
                        $refs.dialogo_filtro_fecha_inicio.save(filtro_remoto_fecha_inicio)
                      "
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs6 sm6 md2>
                <v-dialog
                  ref="dialogo_filtro_fecha_fin"
                  v-model="dialogo_filtro_fecha_fin"
                  :return-value.sync="filtro_remoto_fecha_fin"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="filtro_remoto_fecha_fin_formateada"
                      label="Fecha fin"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filtro_remoto_fecha_fin"
                    :min="fecha_fin_minima"
                    :max="fecha_fin_maxima"
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialogo_filtro_fecha_fin = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="
                        $refs.dialogo_filtro_fecha_fin.save(filtro_remoto_fecha_fin)
                      "
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs2 sm2 md2>
                <v-text-field
                  v-model="filtros_albaranes.codigo_cliente"
                  type="number"
                  label="Cód. Cliente"
                ></v-text-field>
              </v-flex>
              <v-flex xs9 sm5 md5>
                <v-text-field
                  v-model="filtros_albaranes.otros"
                  append-icon="search"
                  label="Cód. Albarán o Barras"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-icon class="mt-2" @click="limpiarFiltrosAlbaranes()" color="red"
                  >clear</v-icon
                >
              </v-flex>
            </v-layout>
          </v-container>
        </template>
        <template v-slot:item.creacion="{ item }">{{
          formatearFecha(new Date(item.creacion).toISOString().substring(0, 10))
        }}</template>
        <template v-slot:item.efecto="{ item }">
          <span v-if="item.efecto">{{
            formatearFecha(new Date(item.efecto).toISOString().substring(0, 10))
          }}</span>
          <v-icon v-else small class="mr-2" @click="abrirConfirmarCerrarAlbaran(item)"
            >mdi-timer-sand</v-icon
          >
        </template>
        <template v-slot:item.articulos="{ item }">
          <v-icon small class="mr-2" @click="abrirDialogoArticulos(item)"
            >mdi-format-list-checkbox</v-icon
          >
        </template>
        <template v-slot:item.accion="{ item }">
          <v-icon v-if="!item.efecto" small class="mr-2" @click="abrirEditarAlbaran(item)"
            >edit</v-icon
          >
          <v-icon
            v-if="!item.efecto"
            small
            class="mr-2"
            @click="abrirEliminarAlbaran(item)"
            >delete</v-icon
          >
        </template>
      </v-data-table>

      <v-dialog v-model="dialogo_albaran" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="albaran.cod_cliente"
                    label="*Cód.Cli"
                    type="Number"
                    min="1"
                    step="1"
                    :readonly="editando || eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="albaran.cod_albaran"
                    label="Cód. Albaran"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5 md5>
                  <v-text-field
                    v-model="albaran.cod_barras"
                    label="Código de barras"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 v-show="!!validaMensaje.length">
                  <div
                    class="red--text"
                    v-for="v in validaMensaje"
                    :key="v"
                    v-text="v"
                  ></div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" @click="cerrarDialogoAlbaran">Cancelar</v-btn>
            <v-btn v-if="creando" color="primary darken-1" @click="crearAlbaran"
              >Insertar</v-btn
            >
            <v-btn
              v-else-if="editando"
              color="primary darken-1"
              @click="actualizarAlbaran"
              >Actualizar</v-btn
            >
            <v-btn v-else color="primary darken-1" @click="eliminarAlbaran"
              >Eliminar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogo_confirmar_cerrar_albaran" max-width="360">
        <v-card>
          <v-card-title>
            <span class="headline">Albarán {{ albaran.cod_albaran }}</span>
          </v-card-title>
          <v-card-text
            >¿Confirma cerrar el albarán y que tome efecto la entrada de artículos? La
            acción no se puede deshacer.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" @click="cerrarDialogoConfirmarCerrarAlbaran()"
              >Cancelar</v-btn
            >
            <v-btn color="primary darken-1" @click="cerrarAlbaran()">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogo_articulos"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Artículos del Albarán {{ albaran.cod_albaran }}</span>
          </v-card-title>
          <v-divider class="mx-2" inset horizonatal></v-divider>
          <v-card-text>
            <v-data-table
              :headers="headers_articulos"
              :items="articulos"
              :items-per-page="50"
              :sort-by="['creacion', 'sku_cliente']"
              :sort-desc="[true, false]"
              :search="filtros_articulos.otros"
              item-key="_id"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs10 sm10 md10> </v-flex>
                    <v-flex xs1 sm1 md1>
                      <v-btn
                        class="red mx-1"
                        fab
                        small
                        dark
                        @click.native="$refs.file_input_albaran_articulos.click()"
                      >
                        <v-icon>mdi-microsoft-excel</v-icon>
                      </v-btn>
                      <input
                        type="file"
                        style="display: none"
                        ref="file_input_albaran_articulos"
                        accept=".xlsx, .odt"
                        @change="importarExcel2AlbaranArticulos($event)"
                      />
                    </v-flex>
                    <v-flex xs1 sm1 md1>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="blue mx-1"
                            fab
                            small
                            dark
                            href="/plantillas/PlantillaImportarArticulosAlbaran.xlsx"
                          >
                            <v-icon v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
                          </v-btn>
                        </template>
                        <span> Plantilla Importar Artículos </span>
                      </v-tooltip>
                    </v-flex>

                    <!-- <v-flex xs9 sm8 md8>
                      <v-text-field
                        v-model="filtros_articulos.otros"
                        append-icon="search"
                        label="Sku, cód barras o nombre"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 sm1 md1>
                      <v-icon class="mt-2" @click="limpiarFiltrosArticulos()" color="red">clear</v-icon>
                    </v-flex>-->

                    <v-flex xs2 sm1 md1> Picking:</v-flex>
                    <v-flex xs9 sm6 md6>
                      <v-text-field
                        v-model="codBarrasArticulo"
                        autofocus
                        label="Cód barras"
                        v-on:keyup.13="agregarArticuloPorCodBarras()"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </template>
              <template v-slot:item.cantidad="{ item }">
                <v-chip
                  :color="item.cantidad == item.cantidadPrevista ? 'green' : 'red'"
                  dark
                  >{{ item.cantidad }}</v-chip
                >
              </template>
              <template v-slot:item.accion="{ item }">
                <v-icon small class="mr-2" @click="eliminarArticulo(item)">delete</v-icon>
              </template>
            </v-data-table>
            <v-flex xs12 sm12 md12 v-show="!!validaMensaje.length">
              <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" @click="cerrarDialogoArticulo">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import XLSX from "xlsx";

const CREANDO = 1;
const EDITANDO = 2;
const ELIMINANDO = 3;

export default {
  data() {
    return {
      codBarrasArticulo: "",
      dialogo_albaran: false,
      dialogo_confirmar_cerrar_albaran: false,
      dialogo_articulos: false,
      filtros_albaranes: {
        codigo_cliente: "",
        otros: "",
      },
      dialogo_filtro_fecha_inicio: false,
      dialogo_filtro_fecha_fin: false,
      filtro_remoto_fecha_inicio: null,
      filtro_remoto_fecha_inicio_formateada: null,
      filtro_remoto_fecha_fin: null,
      filtro_remoto_fecha_fin_formateada: null,
      filtros_articulos: {
        otros: "",
      },
      albaranes: [],
      articulos: [],
      headers_albaranes: [
        {
          text: "F. Creación",
          value: "creacion",
          align: "center",
          sortable: true,
          filterable: false,
        },
        {
          text: "F. Efecto",
          value: "efecto",
          align: "center",
          sortable: true,
          filterable: false,
        },
        {
          text: "Cód. Cliente",
          value: "cliente.codigo",
          align: "center",
          sortable: true,
          filter: (value) => {
            if (!this.filtros_albaranes.codigo_cliente) {
              return true;
            }
            return value == parseInt(this.filtros_albaranes.codigo_cliente);
          },
        },
        { text: "Cód. Albarán", value: "cod_albaran", sortable: true },
        { text: "Cód. Barras", value: "cod_barras", sortable: true },
        {
          text: "Artículos",
          value: "articulos",
          align: "center",
          sortable: true,
        },
        {
          text: "Acciones",
          value: "accion",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ],
      headers_articulos: [
        {
          text: "Sku interno",
          value: "sku_interno",
          sortable: true,
          filterable: false,
        },
        {
          text: "Sku cliente",
          value: "sku_cliente",
          sortable: true,
          filterable: false,
        },
        {
          text: "Cód barras",
          value: "cod_barras",
          sortable: false,
          filterable: false,
        },
        {
          text: "Nombre",
          value: "nombre",
          sortable: true,
          filterable: false,
        },
        {
          text: "Cantidad Prevista",
          value: "cantidadPrevista",
          sortable: false,
          filterable: false,
        },
        {
          text: "Cantidad Recibida",
          value: "cantidad",
          sortable: false,
          filterable: false,
        },
        {
          text: "Acciones",
          value: "accion",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ],
      albaran: {
        _id: "",
        cod_cliente: "",
        sku_interno: "",
        sku_cliente: "",
        cod_barras: "",
        creacion: "",
      },
      validaMensaje: [],
      accion: CREANDO,
    };
  },
  computed: {
    esAdministrador() {
      return this.$store.state.usuario.rol == "Administrador";
    },
    formTitle() {
      console.log(
        "formTitle this.creando",
        this.creando
          ? "Nuevo registro"
          : this.eliminando
          ? "Eliminar registro"
          : "Editar registro"
      );
      switch (this.accion) {
        case CREANDO:
          return "Nuevo registro";
        case EDITANDO:
          return "Editar registro";
        case ELIMINANDO:
          return "Eliminar registro";
      }
      console.log("No coge el switch");
      return this.creando
        ? "Nuevo registro"
        : this.eliminando
        ? "Eliminar registro"
        : "Editar registro";
    },
    creando() {
      console.log("creando this.accion", this.accion);
      console.log("CREANDO", CREANDO);
      return this.accion == CREANDO;
    },
    editando() {
      console.log("editando this.accion", this.accion);
      console.log("EDITANDO", EDITANDO);
      return this.accion == EDITANDO;
    },
    eliminando() {
      console.log("eliminando this.accion", this.accion);
      console.log("ELIMINANDO", ELIMINANDO);
      return this.accion == ELIMINANDO;
    },
    fecha_inicio_inicial() {
      let fecha = new Date();
      fecha.setDate(new Date().getDate() - 14);
      return fecha.toISOString().substring(0, 10);
    },
    fecha_inicio_maxima() {
      let hoy = new Date();
      hoy.setDate(new Date().getDate());
      console.log("hoy", hoy.toISOString().substring(0, 10));
      console.log("this.filtro_remoto_fecha_fin", this.filtro_remoto_fecha_fin);
      let fecha =
        hoy.toISOString().substring(0, 10) < this.filtro_remoto_fecha_fin
          ? hoy.toISOString().substring(0, 10)
          : this.filtro_remoto_fecha_fin;
      console.log("fecha_inicio_maxima", fecha);
      return fecha;
    },
    fecha_fin_minima() {
      return this.filtro_remoto_fecha_inicio;
    },
    fecha_fin_maxima() {
      let fecha = new Date();
      fecha.setDate(new Date().getDate());
      return fecha.toISOString().substring(0, 10);
    },
  },
  watch: {
    dialogo_albaran(val) {
      val || this.cerrarDialogoAlbaran();
    },
    dialogo_articulos(val) {
      val || this.cerrarDialogoConfirmarCerrarAlbaran();
    },
    validaMensaje(val) {
      console.log("watch validaMensaje", val);
      console.log("watch this.dialogo_albaran", this.dialogo_albaran);
      console.log("watch this.dialogo_articulos", this.dialogo_articulos);
      if (val.length > 0 && !this.dialogo_albaran && !this.dialogo_articulos) {
        this.$alert(val[0]);
      }
    },
    filtro_remoto_fecha_inicio(val) {
      console.log("filtro_remoto_fecha_inicio", val);
      let fecha = this.filtro_remoto_fecha_inicio;
      this.filtro_remoto_fecha_inicio_formateada = this.formatearFecha(fecha);
      console.log(
        "filtro_remoto_fecha_inicio_formateada",
        this.filtro_remoto_fecha_inicio_formateada
      );
      this.listar();
    },
    filtro_remoto_fecha_fin(val) {
      console.log("filtro_remoto_fecha_fin", val);
      let fecha = this.filtro_remoto_fecha_fin;
      this.filtro_remoto_fecha_fin_formateada = this.formatearFecha(fecha);
      console.log(
        "filtro_remoto_fecha_fin_formateada",
        this.filtro_remoto_fecha_fin_formateada
      );
      this.listar();
    },
  },
  created() {
    this.listar();
    this.filtro_remoto_fecha_inicio = this.fecha_inicio_inicial;
    console.log("this.filtro_remoto_fecha_inicio", this.filtro_remoto_fecha_inicio);
    this.filtro_remoto_fecha_fin = this.fecha_fin_maxima;
  },
  methods: {
    crearAlbaran() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      if (!this.esValido()) {
        return;
      }
      axios
        .post(
          "albaran/crear",
          {
            cod_cliente: this.albaran.cod_cliente,
            cod_albaran: this.albaran.cod_albaran,
            cod_barras: this.albaran.cod_barras,
          },
          configuracion
        )
        .then(function (response) {
          console.log("response", response);
          me.limpiar();
          me.cerrarDialogoAlbaran();
          me.listar();
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    listar() {
      if (!this.filtro_remoto_fecha_inicio || !this.filtro_remoto_fecha_fin) {
        return;
      }
      let me = this;
      let header = { Token: this.$store.state.token };
      let params = {
        fecha_inicio: this.filtro_remoto_fecha_inicio,
        fecha_fin: this.filtro_remoto_fecha_fin,
      };
      let configuracion = { headers: header, params: params };
      console.log("configuracion", configuracion);
      axios
        .get("albaran/listar", configuracion)
        .then(function (response) {
          me.validaMensaje = [];
          me.albaranes = response.data;
          console.log("me.albaranes", me.albaranes);
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    actualizarAlbaran() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      if (!this.esValido()) {
        return;
      }
      axios
        .put(
          "albaran/actualizar",
          {
            _id: this.albaran._id,
            cod_albaran: this.albaran.cod_albaran,
            cod_barras: this.albaran.cod_barras,
          },
          configuracion
        )
        .then(function (response) {
          me.limpiar();
          me.cerrarDialogoAlbaran();
          me.listar();
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    cerrarAlbaran() {
      this.cerrarDialogoConfirmarCerrarAlbaran();
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("albaran/cerrar", { _id: this.albaran._id }, configuracion)
        .then(function (response) {
          me.validaMensaje = [];
          me.cerrarDialogoAlbaran();
          me.listar();
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    eliminarAlbaran() {
      let me = this;
      let header = { Token: this.$store.state.token };
      axios
        .delete("albaran/eliminar", {
          data: { _id: me.albaran._id },
          headers: header,
        })
        .then(function (response) {
          me.limpiar();
          me.cerrarDialogoAlbaran();
          me.listar();
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    /*****************************/
    /*** ARTÍCULOS DEL ALABRAN ***/
    /*****************************/
    listarArticulos() {
      console.log("listarArticulos");
      let me = this;
      let header = { Token: this.$store.state.token };
      let params = {
        _id: this.albaran._id,
      };
      let configuracion = { headers: header, params: params };
      axios
        .get("albaran/consultarPorId", configuracion)
        .then(function (response) {
          me.validaMensaje = [];
          me.articulos = response.data.articulos;
          console.log("me.articulos", me.articulos);
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    agregarArticulos(articulos) {
      console.log("agregarArticulos articulos", articulos);
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .post(
          "albaran/agregarArticulos",
          { _id: this.albaran._id, articulos: articulos },
          configuracion
        )
        .then(function (response) {
          me.validaMensaje = [];
          me.articulos = response.data.articulos;
          console.log("me.albaran", me.albaran);
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    agregarArticuloPorCodBarras() {
      console.log(
        "agregarArticuloPorCodBarras codBarrasArticulo:",
        this.codBarrasArticulo
      );
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .post(
          "albaran/agregarArticuloPorCodBarras",
          { _id: this.albaran._id, codBarrasArticulo: this.codBarrasArticulo },
          configuracion
        )
        .then(function (response) {
          me.validaMensaje = [];
          me.articulos = response.data.articulos;
          console.log("me.albaran", me.albaran);
          me.codBarrasArticulo = "";
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
          me.codBarrasArticulo = "";
        });
    },
    eliminarArticulo(item) {
      console.log("eliminarArticulo item", item);
      let me = this;
      let header = { Token: this.$store.state.token };
      axios
        .delete("albaran/eliminarArticulo", {
          data: { _id: me.albaran._id, articulo: item },
          headers: header,
        })
        .then(function (response) {
          me.validaMensaje = [];
          me.listarArticulos();
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    /**************************************************/
    /*** AUXILIARES Y FUNCIONES PROPIAS DE LA VISTA ***/
    /**************************************************/
    abrirNuevoAlbaran() {
      this.validaMensaje = [];
      this.dialogo_albaran = true;
    },
    abrirEditarAlbaran(item) {
      console.log("editar", item);
      this.albaran._id = item._id;
      if (item.cliente) {
        this.albaran.cod_cliente = item.cliente.codigo;
      }
      this.albaran.cod_albaran = item.cod_albaran;
      this.albaran.cod_barras = item.cod_barras;
      this.validaMensaje = [];
      this.dialogo_albaran = true;
      this.accion = EDITANDO;
    },
    abrirEliminarAlbaran(item) {
      this.abrirEditarAlbaran(item);
      this.accion = ELIMINANDO;
    },
    abrirConfirmarCerrarAlbaran(item) {
      this.validaMensaje = [];
      this.albaran = item;
      this.dialogo_confirmar_cerrar_albaran = true;
    },
    abrirDialogoArticulos(item) {
      console.log("abrirDialogoArticulos albaran", item);
      this.albaran = Object.assign({}, item);
      this.listarArticulos();
      this.dialogo_articulos = true;
    },
    formatearFecha(date) {
      if (!date) {
        return null;
      }

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    limpiarFiltrosAlbaranes() {
      console.log("limpiarFiltrosAlbaranes");
      this.filtros_albaranes.codigo_cliente = "";
      this.filtros_albaranes.otros = "";
    },
    limpiarFiltrosArticulos() {
      console.log("limpiarFiltrosArticulos");
      this.filtros_articulos.otros = "";
    },
    esValido() {
      this.validaMensaje = [];
      if (
        isNaN(this.albaran.cod_cliente) ||
        this.albaran.cod_cliente != parseInt(this.albaran.cod_cliente)
      ) {
        this.validaMensaje.push("Código Cliente (Número entero de hasta 6 dígitos)");
      }
      if (!this.albaran.cod_albaran) {
        this.validaMensaje.push(
          "Cód albaran del artículo (texto entre 1-128 caracteres)"
        );
      }
      return this.validaMensaje.length == 0;
    },
    limpiar() {
      console.log("limpiar");
      this.albaran = {
        _id: "",
        cod_cliente: "",
        sku_interno: "",
        sku_cliente: "",
        cod_barras: "",
        creacion: "",
      };
      this.validaMensaje = [];
      this.accion = CREANDO;
      this.articulos = [];
    },
    cerrarDialogoAlbaran() {
      console.log("cerrarDialogoAlbaran");
      this.dialogo_albaran = false;
      this.limpiar();
    },
    cerrarDialogoConfirmarCerrarAlbaran() {
      this.codBarrasArticulo = "";
      this.dialogo_confirmar_cerrar_albaran = false;
    },
    cerrarDialogoArticulo() {
      this.dialogo_articulos = false;
    },
    /*****************************/
    /*** OTRAS FUNCIONALIDADES ***/
    /*****************************/
    exportarAlbaranesExcel() {
      console.log("exportarAlbaranesExcel");
      try {
        let albaranes = [];
        this.albaranes.forEach((alb) => {
          if (
            this.filtros_albaranes.codigo_cliente.length === 0 ||
            this.filtros_albaranes.codigo_cliente == alb.cliente.codigo
          ) {
            console.log("alb", alb);
            alb.resumen_articulos = "";
            alb.total_articulos = 0;
            let i = 1;
            alb.articulos.forEach((art) => {
              alb.resumen_articulos += `Art. ${i}: ${art.nombre} - Cantidad art. ${i}: ${art.cantidad}, `;
              alb.total_articulos += art.cantidad;
              i++;
            });
            if (alb.resumen_articulos.length > 2) {
              alb.resumen_articulos = alb.resumen_articulos.substring(
                0,
                alb.resumen_articulos.length - 2
              );
            }

            albaranes.push({
              Fecha: this.formatearFecha(
                new Date(alb.creacion).toISOString().substring(0, 10)
              ),
              "Fecha Efecto": alb.efecto
                ? this.formatearFecha(new Date(alb.efecto).toISOString().substring(0, 10))
                : "Pendiente",
              "Cód. Cliente": alb.cliente.codigo,
              "Ref. Albarán": alb.cod_albaran,
              "Cód. Barras": alb.cod_barras,
              "Nº Artículos": alb.articulos.length,
              "Total Artículos": alb.total_articulos,
              Artículos: alb.resumen_articulos,
            });
          }
        });
        let worksheet = XLSX.utils.json_to_sheet(albaranes);
        let new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "albaranes");
        XLSX.writeFile(new_workbook, "albaranes.xlsx");
      } catch (error) {
        console.error("export error", error);
      }
    },
    importarExcel2AlbaranArticulos(e) {
      console.log("importarExcel2AlbaranArticulos");
      console.log("e", e);
      console.log(
        "$refs.file_input_albaran_articulos",
        this.$refs.file_input_albaran_articulos
      );

      try {
        let me = this;
        me.validaMensaje = [];
        const fichero_importar_albaran_articulos = e.target.files[0];
        console.log(
          "fichero_importar_albaran_articulos",
          fichero_importar_albaran_articulos
        );

        if (!fichero_importar_albaran_articulos) {
          return;
        }

        if (fichero_importar_albaran_articulos.size > 1000000) {
          me.validaMensaje.push("El fichero no debe sobrepasar 1MB de tamaño");
          return;
        }

        let reader = new FileReader();
        reader.onload = function (e) {
          let articulos_a_importar = null;
          try {
            let data = new Uint8Array(e.target.result);
            let workbook = XLSX.read(data, { type: "array" });
            let sheetName = workbook.SheetNames[0];
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log("Conversión a json");
            articulos_a_importar = XLSX.utils.sheet_to_json(worksheet);
            console.log("articulos_a_importar", articulos_a_importar);
          } catch (error) {
            me.$refs.file_input_albaran_articulos.value = "";
            me.validaMensaje.push("Fichero incorrecto");
            return;
          }
          console.log("fuera del try");
          me.$refs.file_input_albaran_articulos.value = "";

          if (!articulos_a_importar || articulos_a_importar.length === 0) {
            me.validaMensaje.push("Fichero incorrecto o vacío");
            return;
          }

          me.agregarArticulos(articulos_a_importar);

          console.log("Fin de la función");
        };

        reader.readAsArrayBuffer(fichero_importar_albaran_articulos);
      } catch (error) {
        console.error("export error", error);
      }
    },
  },
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0px;
}
</style>
